module.exports = __webpack_public_path__ + "static/media/m-penguin-migration.9112f85b.png";